export const TOKEN_KEY = '@portalcm-token';
export const USERINFO_KEY = '@portalcm-userinfo';
export const USERBLOCK_KEY = '@portalcm-userblock';
export const ATTEMPT_KEY = '@portalcm-attempts';
